import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const LandingPaths: IPaths = {
  Landing: {
    Main: '/',
    Menu: '/Menu',
    ModuleDescription: '/ModuleDescription',
    PaymentResult: '/PaymentResult',
    Cart: '/Cart',
    OrderDetail: '/Order/Detail',
    OrderHistoryOrElhaghieh: '/Order/HistoryOrElhaghieh',
    Error: '/Error',
    Contents: '/Contents',
    SabtElhaghiyeh: '/SabtElhaghiyeh',
  },
};
